import React from "react";

export default function AnalyticsDashboard() {
  return (
    <div>
      <h2>AnalyticsDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}